import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import Chip from '../Chip';
import { PostStatuses } from '../../../Utils/Types';
import CustomIcon from '../CustomIcon';
import { Icons } from '../../../Themes';

const ChipStyled = styled(Chip)(({ theme }: any) => ({
  svg: {
    marginLeft: theme.spacing(1.5),
  },
}));

function StatusBadge({ status, onClick, size = 'small', ...props }: any) {
  const getChipsProps = () => {
    switch (status.keyword) {
      case PostStatuses.TO_MODERATE:
        return {};
      case PostStatuses.REJECTED:
        return {};
      case PostStatuses.TODO:
      case PostStatuses.ANSWERED:
        return {
          variant: 'outlined',
          color: 'default',
        };
      case PostStatuses.DUPLICATE:
        return {
          variant: 'outlined',
          color: 'default',
        };
      case PostStatuses.SELECTED:
        return {
          variant: 'outlined',
          color: 'secondary',
        };

      case PostStatuses.DOING:
        return {
          variant: 'outlined',
          color: 'secondary',
        };

      case PostStatuses.IN_PROGRESS:
        return {
          color: 'secondary',
          icon: <CustomIcon src={Icons.posts.status.in_progress} size={16} color="white" />,
        };

      case PostStatuses.VALIDATED:
        return {
          color: 'secondary',
          icon: <CustomIcon src={Icons.posts.status.concretized} size={16} color="white" />,
        };

      case PostStatuses.DONE:
        return {
          color: 'primary',
          icon: <CustomIcon src={Icons.posts.status.concretized} size={16} color="white" />,
        };

      default:
        return {};
    }
  };

  if (!status) {
    return null;
  }

  return (
    <ChipStyled
      label={status.title}
      onClick={onClick}
      clickable={!!onClick}
      size={size}
      {...getChipsProps()}
      {...props}
    />
  );
}

StatusBadge.propTypes = {
  size: PropTypes.oneOf(['medium', 'small']),
  status: PropTypes.shape({
    content: PropTypes.string,
    keyword: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  typographyComponent: PropTypes.string,
};

export default StatusBadge;
